import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { PermissionFilter } from '../../../../../AngularJS/Goals/Gamification/Models/permission-filter';
import { CvCustomDialogService } from '../../../../reusables/custom-dialog/cv-custom-dialog.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Injectable({
  providedIn: 'root'
})
export class PointStorePermissionService {

  private _unauthorizedMessage = 'Unauthorized Access. You do not have the proper permissions to complete this action.';
  private _edit = 'WRITE';
  private _create = 'CREATE';

  get unauthorizedMessage(): string {
    return this._unauthorizedMessage;
  }

  getEditPermissionName(): string {
    return this._edit;
  }

  getCreatePermissionName(): string {
    return this._create;
  }

  pointStorePermissionObj = {
    permissionList: null,
  }

  constructor(
    private cvApiService: CVApiService,
    private dialogService: CvCustomDialogService,
    public config: CvConfigurationService,
    private CVLocalizationService: CVLocalizationService,
    private cvConfigurationService: CvConfigurationService,
  ) {
    this.CVLocalizationService.GetSection("Common");
    this.CVLocalizationService.GetSection("MarketPlace_Management_Product_Operation");
  }

  async loadPermission() {
    const permissionFilter: PermissionFilter = {
      type: 'list',
      isCxone: this.cvConfigurationService.isCxOne,
    }
    try {
      const url = "/api/v1/gamification/marketplace/permission";
      let { data, status_code, message: prompt } = await this.cvApiService.post(url, permissionFilter);
      if (status_code === 200) {
        this.pointStorePermissionObj.permissionList = data;
      } else {
        this.dialogService.showDialog(this.CVLocalizationService.getCachedText("MarketPlace_Management_Product_Operation", "Unauthorized_Access", "Unauthorized Access"), this.CVLocalizationService.getCachedText("MarketPlace_Management_Messages", "Permission_Empty_Data", prompt), 1, this.CVLocalizationService.getCachedText("Common", "Cancel_Button", "Cancel"), this.CVLocalizationService.getCachedText("Common", "OK", "OK"), true);
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  checkPermission(permision: string): boolean {
    let check: any[] = [];
    if (this.pointStorePermissionObj.permissionList) {
      check = this.pointStorePermissionObj.permissionList.filter((p: string) => p === permision);
    }
    return check.length > 0;
  }

  async getPermission(permissionFilter: PermissionFilter) {
    try {
      permissionFilter.isCxone = this.cvConfigurationService.isCxOne;
      const url = "/api/v1/gamification/marketplace/permission";
      let { data, status_code, message: prompt } = await this.cvApiService.post(url, permissionFilter);
      if (status_code === 200) {
        return data;
      } else {
        if (this.config.isCxOne) {
          this.dialogService.showDialog(this.CVLocalizationService.getCachedText("MarketPlace_Management_Product_Operation", "Unauthorized_Access", "Unauthorized Access"), this.CVLocalizationService.getCachedText("MarketPlace_Management_Messages", "Permission_Empty_Data", prompt), 1, this.CVLocalizationService.getCachedText("Common", "Cancel_Button", "Cancel"), this.CVLocalizationService.getCachedText("Common", "OK", "OK"), true);
        } else {
          await this.validationMessage(prompt);
        }
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  validationMessage(prompt: string) {
    return new Promise((resolve, reject) => {

      let validation = new window["CVVALIDATION"].ValidationInstance();
      validation.succeeded = false;
      validation.addValidationError(prompt, true);

      window["showConfirmDialog"]("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
        [
          {
            text: this.CVLocalizationService.getCachedText("Common", "OK", "OK"),
            click: () => {
              let dialogMsg: any = $(".errorDialog");
              dialogMsg.dialog("close");
              return resolve(true);
            }
          },
          {
            text: this.CVLocalizationService.getCachedText("Common", "Cancel_Button", "Cancel"),
            click: () => {
              let dialogMsg: any = $(".errorDialog");
              dialogMsg.dialog("close");
              return reject(false);
            }
          }
        ], this.CVLocalizationService.getCachedText("MarketPlace_Management_Product_Operation", "Unauthorized_Access", "Unauthorized Access"), "Warning");
    });
  }

}
